import type { ShigoAccessibleRoute } from './accessPolicy.types';

export const publicRoutes = new Set(['/login', '/logout']);

export const accessibleRoutes: readonly ShigoAccessibleRoute[] = [
  '/',
  '/campaigns/agencies',
  '/campaigns/brands',
  '/campaigns/supply/apps',
  '/campaigns/campaigns',
  '/campaigns/creatives',
  '/targeting',
  '/admin/users',
  '/admin/changelog',
  '/a2v/assets',
  '/a2v/network-template',
  '/supply/blocked-list/creatives',
  '/networks',
  '/supply',
  '/supply/publishers',
  '/supply/placements',
  '/supply/lists/all',
  '/supply/apps',
  '/supply/domains',
  '/supply/tailored-supply',
  '/supply/endpoint-generator',
  '/supply/ads-txt/records',
  '/supply/ads-txt/apps',
  '/supply/ads-txt/domains',
  '/demand/owners',
  '/demand/partners',
  '/demand/integrations',
  '/demand/deals',
  '/demand',
  '/debug',
  '/reporting',
  '/reporting/report-explorer',
  '/reporting/performance-analyzer',
  '/reporting/network-performance',
  '/reporting/saved-reports',
];
